import { copy } from "../content/copy";
import type { UseCase } from "../content/useCases";

interface UseCaseCardProps {
  useCase: UseCase;
}

export function UseCaseCard({ useCase }: UseCaseCardProps) {
  return (
    <article className="card usecase-card">
      <header className="usecase-card__header">
        <span className="usecase-card__icon" aria-hidden="true">
          {useCase.icon}
        </span>
        <h3 className="usecase-card__name">{useCase.name}</h3>
      </header>
      <div className="usecase-card__pain">
        <span className="usecase-card__label">The pain today</span>
        <p>{useCase.pain}</p>
      </div>
      <div className="usecase-card__vision">
        <span className="usecase-card__label">With {copy.brand}</span>
        <p>{useCase.vision}</p>
      </div>
    </article>
  );
}
